import React, { useContext } from 'react'

import { Box, BoxProps, Loader, makeAppStyles, ReportRange, Typography, TypographyProps } from '@percept/mui'

import { TimeRangeSelect, timeseriesPeriodCalculators } from './OrgUnitPerformance'

import { DashboardReferenceDatesContext } from './ReferenceDatesProvider'

import { OrgUnitHomePageContext } from 'contexts'


export type PerformanceDateHeaderProps = {
  TypographyProps?: Partial<Omit<TypographyProps, 'children'>>
} & BoxProps

const useStyles = makeAppStyles( theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
  },
  comparisonSeparator: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 0.75),
  },
}))


export const DateHeader = ({
  TypographyProps,
  ...props
}: PerformanceDateHeaderProps): JSX.Element | null => {
  const [{ range }, setState] = useContext(OrgUnitHomePageContext)
  const { performanceSummary } = useContext(DashboardReferenceDatesContext)
  const classes = useStyles()
  const [start, end] = (
    performanceSummary.maxDate ?
      timeseriesPeriodCalculators[range](performanceSummary.maxDate) :
      [null, null]
  )
  return (
    <Box display='flex' alignItems='center' {...props}>
      <TimeRangeSelect
        value={range}
        TriggerProps={{
          variant: 'outlined',
        }}
        onChange={(value): void => {
          setState({ range: value })
        }} />
      { start && end ? (
        <Typography className={classes.root} {...TypographyProps}>
          <ReportRange start={start} end={end} disableTypography />
        </Typography>
      ) : (
        <Loader ml={2} preset='inline' />
      )}

    </Box>
  )
}
